import _extends from 'babel-runtime/helpers/extends';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { progressModel } from '@rosetta/gaia-progress';
import { withPlayer } from '../step/player/withPlayer';
import { submissionsSelectors } from '../submissions/redux/submissions-reducer';

var withSubmissionPlayerBase = withPlayer(function (props) {
  return {
    get _latest_submission() {
      if (!props.submissions) {
        return null;
      }
      var sorted = props.submissions.filter(function (s) {
        return s.activityStepId === props.activityStepId;
      }).sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      return sorted[0];
    },

    get initialStepStatus() {
      var activityProgress = progressModel.getActivityProgress(props.sequenceProgress, props.activity.activityId);
      var aSubmission = this._latest_submission;
      var skipped = false;
      var ungradable = false;
      var completed = false;
      // sometimes the progress gets lost but we can reconstruct from the submission
      //  and prevent the user from getting errors
      var needsReconstructing = aSubmission && (!activityProgress || activityProgress.skipped);
      if (needsReconstructing) {
        skipped = false;
        ungradable = !!aSubmission.ungradable;
        completed = !skipped && !ungradable;
      } else if (activityProgress) {
        skipped = progressModel.activityIsSkipped(activityProgress);
        ungradable = progressModel.extendedActivityIsUngradable(activityProgress);
        completed = !skipped && !ungradable;
      }
      var initialStepStatus = props.player.initialStepStatus;
      var submissionValue = void 0;
      if (completed && aSubmission) {
        submissionValue = !!aSubmission.submissionAudioUri ? aSubmission.submissionAudioUri : aSubmission.submissionText;
      }
      return _extends({}, initialStepStatus, {
        skipped: skipped,
        completed: completed,
        values: submissionValue || initialStepStatus.values
      });
    },

    get feedback() {
      var player = props.player;

      var aSubmission = this._latest_submission;
      if (aSubmission && aSubmission.gradedOn) {
        return ['_player_title_completed'];
      } else if (player.completed) {
        return ['_expert_review_answer_already_submitted'];
      }
      return player.feedback;
    }
  };
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    submissions: submissionsSelectors.getSubmissions(state)
  };
};

var mapActionsToProps = {};

export var withSubmissionPlayer = compose(connect(mapStateToProps, mapActionsToProps), withSubmissionPlayerBase);